import type { TraceScene } from '../../exports/scene';

/** Keep loaded owners' bytes intact when registering another baked mesh. */
export function unusedMeshAssetName(resources: Pick<TraceScene['resources'], 'getAsset'>, baseName: string): string {
    let fileName = `${baseName}.glb`;
    for (let revision = 1; resources.getAsset(`assets/${fileName}`); revision++) {
        fileName = `${baseName}-r${revision}.glb`;
    }
    return fileName;
}
